import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'

const Bedroom = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Bedroom Design App to Plan Layouts and Create Your Dream Space"
        subtitle="Use our bedroom layout app to design a bedroom you love — arrange furniture, preview decor, and bring your vision to life virtually."
        bg={headerBg}
        meta={{
          title: 'Bedroom Design App | Layout Planner for Dream Bedrooms',
          description: 'Design your dream bedroom with our bedroom design app and layout planner. Visualize furniture, plan room layouts, and customize your space — all from your phone.'
        }}
        alt="Bedroom design app interface showcasing virtual bedroom layout planning and furniture placement."
      />
      <Join
        title="Join Over 10 Million Users Designing Bedrooms with DecorMatters"
        description="Design your dream bedroom with the DecorMatters bedroom design app — the easiest way to plan layouts, place furniture, and visualize decor. Whether you're updating a cozy nook or starting a full bedroom makeover, our bedroom layout app helps you create a functional and beautiful space from your phone. Get inspired, test design ideas, and customize every detail virtually before making a single purchase."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Smarter Bedroom Design with Augmented Reality and AI Tools</H2>
            </Show>
            <Text>
              The DecorMatters bedroom layout app uses cutting-edge Augmented Reality (AR) and Artificial Intelligence (AI) to make interior design simple and accurate. Visualize furniture, layout changes, and color schemes in your real bedroom using
              AR. Our AI-powered recommendations help you discover furniture, decor, and layout ideas that match your style and space — faster than ever.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Smarter Bedroom Design with Augmented Reality and AI Tools</H2>
            </Show>
            <Image src={img1} alt="Using augmented reality in a bedroom layout app to preview furniture and decor placement virtually." />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Plan Your Space with Our Bedroom Layout Planner</H2>
            </Show>
            <Text>
              Start your bedroom design in minutes with intuitive tools made for every skill level. Upload a photo of your room or choose a template to begin. Use our drag-and-drop layout planner to rearrange furniture, change colors, test decor
              ideas, and visualize your entire space virtually. The DecorMatters bedroom layout app gives you total freedom to design a bedroom that fits your style, space, and lifestyle — all from your phone.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Plan Your Space with Our Bedroom Layout Planner</H2>
            </Show>
            <Image src={img2} alt="Virtual bedroom planner with drag-and-drop tools for rearranging furniture and testing layout designs." />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Premium Tools in the DecorMatters Bedroom Design App</H2>
            </Show>
            <Text>
              Take your bedroom layout to the next level with a DecorMatters membership. Our upgraded tools give you more control, more accuracy, and more creativity — so you can design a bedroom that feels exactly right. With Premium, you can:
              <br />
              <br />
              ● Upload real bedroom photos for personalized planning
              <br />
              ● Use the AR ruler to measure and preview furniture in your space
              <br />
              ● Erase backgrounds for cleaner design mockups
              <br />
              ● Access exclusive tools to plan your bedroom faster and smarter
              <br />
              <br />
              Whether you're doing a full remodel or just refreshing your layout, Premium gives you everything you need to design a bedroom with confidence.
            </Text>
            <Button onClick={openLogin}>Unlock Premium Tools</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Premium Tools in the DecorMatters Bedroom Design App</H2>
            </Show>
            <Image src={img3} alt="Premium bedroom planner tools including AR ruler, background eraser, and wishlist functionality." />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img4} alt="Mobile view of a bedroom design app used to create, preview, and plan a complete bedroom layout." />
            <Content>
              <H2>Start Designing Your Bedroom Today</H2>
              <Text>
                Download the DecorMatters bedroom design app to plan layouts, place furniture, and design your perfect bedroom from your phone. Whether you're creating a new layout or updating your current space, our bedroom planner gives you the
                tools to visualize, customize, and bring your design to life — all in one app.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Bedroom
